import { render, staticRenderFns } from "./AutoPortfolioView.vue?vue&type=template&id=fa0e250c&scoped=true&"
import script from "./AutoPortfolioView.vue?vue&type=script&lang=js&"
export * from "./AutoPortfolioView.vue?vue&type=script&lang=js&"
import style0 from "./AutoPortfolioView.vue?vue&type=style&index=0&id=fa0e250c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa0e250c",
  null
  
)

export default component.exports